const StateEnums = {
    Nebraska: "NE",
};

const CountyEnums = {
    OutOfState: "Out of State",
};

export { StateEnums, CountyEnums };
